// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__159fl","detailsBorder":"styles_detailsBorder__vo4ld"};